import { Routes } from '@angular/router';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';

export const AUTH_ROUTES: Routes = [{ path: 'unauthorized', component: UnauthorizedComponent }]; // sets up routes constant where you define your routes
